"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = exports.ControlledSelect = void 0;
var _jsxRuntime = require("@emotion/react/jsx-runtime");
var React = _interopRequireWildcard(require("react"));
var _reactHookForm = require("react-hook-form");
var _reactUid = require("react-uid");
var _controlContainer = require("./controlContainer");
var _rawSelect = require("./rawControls/rawSelect");
var _iconTypes = require("../../styles/icon-types");
var colors = _interopRequireWildcard(require("wnd-themes/lib/colorPalette"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Select = exports.Select = /*#__PURE__*/React.forwardRef(({
  id,
  label,
  className,
  options,
  disabled,
  onSelectChange,
  defaultValue,
  autoComplete,
  required,
  hasError,
  validationErrorId,
  name,
  value,
  isSearchable,
  placeholder,
  hidden,
  variant,
  tooltip
}, ref) => {
  const inputId = (0, _reactUid.useUID)();
  if (!name) {
    console.warn('A name should be provided when using react-hook-form controller');
  }
  return (0, _jsxRuntime.jsx)(_controlContainer.ControlContainer, {
    label: label,
    hasError: hasError,
    className: className,
    required: required,
    inputId: id ?? inputId,
    tooltip: tooltip,
    children: (0, _jsxRuntime.jsx)(_rawSelect.RawSelect, {
      inputId: id ?? inputId,
      validationErrorId: validationErrorId,
      required: required,
      hasError: hasError ?? false,
      placeholder: placeholder,
      disabled: disabled ?? false,
      hidden: hidden,
      onSelectChange: onSelectChange,
      value: value,
      defaultValue: defaultValue,
      autoComplete: autoComplete,
      options: options,
      ref: ref,
      isSearchable: isSearchable,
      insetIcon: hasError ? _iconTypes.Icons.Warning : undefined,
      iconColor: colors.validationErrorRed,
      variant: variant
    })
  });
});
Select.displayName = 'Select';
const ControlledSelect = ({
  label,
  className,
  options,
  disabled,
  onSelectChange,
  defaultValue,
  autoComplete,
  required,
  hasError,
  validationErrorId,
  rules,
  name,
  isSearchable,
  placeholder,
  hidden,
  variant,
  tooltip
}) => {
  const reactSelectRef = React.useRef(null);
  const onFocus = React.useCallback(() => {
    // eslint-disable-next-line no-unused-expressions
    reactSelectRef.current?.focus();
  }, [reactSelectRef]);
  const handleSelectChange = React.useCallback((option, onChange) => {
    if (onSelectChange) {
      onSelectChange(option.value);
    }
    onChange(option.value);
  }, []);
  return (0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
    name: name ?? '',
    render: ({
      onChange,
      value
    }) => {
      let matchedOption;
      for (const option of options ?? []) {
        if (option.options) {
          matchedOption = option.options.find(option => option.value === value);
          if (matchedOption) {
            break;
          }
        } else {
          if (option.value === value) {
            matchedOption = option;
            break;
          }
        }
      }
      return (0, _jsxRuntime.jsx)(Select, {
        name: name,
        label: label,
        hasError: hasError,
        className: className,
        required: required,
        hidden: hidden,
        disabled: disabled,
        onSelectChange: option => handleSelectChange(option, onChange),
        value: matchedOption ?? null,
        defaultValue: defaultValue,
        placeholder: placeholder,
        autoComplete: autoComplete,
        "aria-required": required,
        "aria-invalid": hasError,
        "aria-describedby": validationErrorId,
        options: options,
        ref: reactSelectRef,
        isSearchable: isSearchable,
        variant: variant,
        tooltip: tooltip
      });
    },
    rules: rules,
    onFocus: onFocus
  });
};
exports.ControlledSelect = ControlledSelect;